import { globalConstants, STORE_BILLING_STATUS } from "../../constants";

const isStripeSubscriptionActive = (billing) => {
  const storeBilling = billing?.billing || billing || {};
  return (
    storeBilling.storeBillingStatus === STORE_BILLING_STATUS.ACTIVE_SUBSCRIPTION
  );
};
const createCompanyStoreOptions = (companyStores) => {
  const storeOptions = companyStores.map((store) => ({
    label: store.storeName,
    value: store.id,
  }));
  return [
    { label: globalConstants.ALL_STORES, value: globalConstants.ALL_STORES },
    ...storeOptions,
  ];
};
export { isStripeSubscriptionActive, createCompanyStoreOptions };
